import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';

import { CommonService } from 'src/app/provide/common.service';
declare var $ :any
@Component({
    selector: 'app-customer-wallet',
    templateUrl: './customer-wallet.component.html',
    styleUrls: ['./customer-wallet.component.scss'],
    standalone: false
})
export class CustomerWalletComponent implements OnInit {

  btn: any = "Pending"
  orderList: any
  count: any
  catName: any
  currentPage: any = 1;
  pageSize: any = 10;
  serviceStatus: any = 'PENDING'
  notFoundData: boolean = false
  headingName: any = 'My Wallet'
  linkerRouteItems: any = [
    // { name:'Home',route: '/service-order-detail'},
    { name: 'Transaction History', route: '/customer-profile' }
  ]

  service
  serviceRole: string;
  myId
  constructor(
    public commonService: CommonService, 
    public router: Router, 
    public sanitizer : DomSanitizer,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    // Check if returning from payment success page
    const isReturningFromPayment = localStorage.getItem('returningFromPayment') === 'true';
    console.log('Returning from payment:', isReturningFromPayment);
    
    if (isReturningFromPayment) {
      // Clear the flag
      localStorage.removeItem('returningFromPayment');
      
      // Refresh with a longer delay to ensure backend has processed the transaction
      console.log('Refreshing wallet transactions after payment with delay');
      setTimeout(() => {
        this.serviceOrderList(1, 3); // Add retry mechanism with max 3 attempts
      }, 3000); // Increased to 3 seconds
    } else {
      // Normal initialization
      this.serviceOrderList();
    }
    
    this.serviceRole = localStorage.getItem("serviceRole")
    this.myId = localStorage.getItem("userId")
    console.log('User ID:', this.myId);
  }

  selectBtn(status) {
    this.serviceOrderList();
  }
  
  getPrice(e: any) {
    return this.commonService.getPrice(e)
  }
  
  isLoading: boolean = false
  wallet: any
  wallet2: any
  
  /**
   * Fetch wallet transactions with retry mechanism
   * @param attempt Current attempt number
   * @param maxAttempts Maximum number of attempts
   */
  serviceOrderList(attempt = 1, maxAttempts = 1) {
    this.isLoading = true;
    this.orderList = []
    this.count = 0;
    
    console.log(`Fetching wallet transactions (attempt ${attempt}/${maxAttempts})`);
    
    const data = {
      page: this.currentPage,
      limit: this.pageSize,
    }
    
    this.commonService.getApi(`deliveryOrders/getWalletTransaction?isCommission=true&page=${this.currentPage}&limit=${this.pageSize}`, 1).subscribe((res: any) => {
      this.isLoading = false
      if (res['responseCode'] == 200) {
        this.commonService.hideSpinner()
        this.orderList = res.result.docs;
        this.wallet = res.result.wallets[0]
        this.wallet2 = res.result
        
        console.log('Wallet data received:', {
          transactions: this.orderList?.length || 0,
          balance: this.wallet?.walletAmount || 0,
          totalWalletAmount: this.wallet?.totalWalletAmount || 0
        });
        
        // Check if we have transactions
        if (res.result.docs && res.result.docs.length > 0) {
          this.notFoundData = false
          // Only set catName if myOrders exists and has elements
          if (res.result.docs.myOrders && res.result.docs.myOrders.length > 0) {
            this.catName = res.result.docs.myOrders[0];
          }
        } else {
          this.notFoundData = true
          
          // If returning from payment and no transactions found, retry if we haven't reached max attempts
          const paymentMethod = localStorage.getItem('paymentMethod');
          const paymentAmount = localStorage.getItem('paymentAmount');
          
          if ((paymentMethod || paymentAmount) && attempt < maxAttempts) {
            console.log(`No transactions found after payment, retrying (${attempt}/${maxAttempts})`);
            setTimeout(() => {
              this.serviceOrderList(attempt + 1, maxAttempts);
            }, 2000);
            return;
          }
        }
        
        this.count = res.result.total
        
        // Force UI update
        this.cdr.detectChanges();
      } else {
        this.notFoundData = true
        console.error('Error response from wallet API:', res['responseMessage']);
      }
    }, (err: any) => {
      this.isLoading = false
      this.notFoundData = true
      
      console.error('Error loading wallet transactions:', err);
      
      if (err.responseCode == 409) {
        this.commonService.hideSpinner()
        this.commonService.errorToast(err.responseMessage)
      } else {
        this.commonService.hideSpinner()
      }
      
      // If returning from payment and error occurred, retry if we haven't reached max attempts
      if (attempt < maxAttempts) {
        console.log(`Error fetching transactions, retrying (${attempt}/${maxAttempts})`);
        setTimeout(() => {
          this.serviceOrderList(attempt + 1, maxAttempts);
        }, 2000);
      }
    })
  }

  changePageNumber(page) {
    this.currentPage = page;
    this.serviceOrderList();
  }

  getWalletName(usType: string) {
    let walletName = usType == "PICKUP_PARTNER" ? "PW" :
      usType == "FIELD_ENTITY" ? "FW" :
        usType == "DELIVERY_PARTNER" ? "DDW" :
          usType == "CUSTOMER" ? "CW" :
            usType == "RETAILER" ? "RW" :
              usType == "ADMIN" ? "XAW" : ""

    if (walletName == 'XAW') {
      if (this.serviceRole == 'DELIVERY') {
        walletName = "DW"
      }
    }

    return walletName
  }
  
  amount;
  OzhoUrl: any
  YocoUrl: any
  ozhoPayment() {
    let url = `order/ozowWalletCheckOut`
    let data = {
      webFailure: this.commonService.webSiteUrl + 'customer-payment-cancel',
      webError: this.commonService.webSiteUrl + 'customer-payment-error',
      webSuccess: this.commonService.webSiteUrl + 'customer-payment-success',
      amount: this.amount,
      testMode: false,
      trxFrom: 'WEB'
    }
    // Store payment information for transaction history
    localStorage.setItem('paymentList', 'wallet');
    localStorage.setItem('paymentMethod', 'OZOW');
    localStorage.setItem('paymentAmount', this.amount);
    
    console.log('Starting Ozow payment with amount:', this.amount);
    
    this.commonService.showSpinner();
    this.commonService.postApi(url, data, 1).subscribe((res: any) => {
      if (res["responseCode"] == 200) {
        this.commonService.hideSpinner();
        console.log('Ozow payment response received:', res.result);
        this.OzhoUrl = res.result
        this.ozhoRedirect()
      } else {
        this.commonService.hideSpinner();
        console.error('Ozow payment error:', res["responseMessage"]);
        this.commonService.errorToast(res["responseMessage"])
      }
    }, (err) => {
      this.commonService.hideSpinner();
      console.error('Server error during Ozow payment:', err);
      this.commonService.errorToast("Server error")
    });
  }
  
  htmlData : any
  // Removed PayFast walletPayment; PayGate/Yoco/Ozow are supported

  yocoPayment() {
    let url = `payment/checkoutWalletYoco`
    let data = {
      webFailure: this.commonService.webSiteUrl + 'customer-payment-cancel',
      webError: this.commonService.webSiteUrl + 'customer-payment-error',
      webSuccess: this.commonService.webSiteUrl + 'customer-payment-success',
      cancelUrl: this.commonService.ozhoBaseUrl,
      errorUrl: this.commonService.ozhoBaseUrl,
      SuccessUrl: this.commonService.ozhoBaseUrl,
      amount: this.amount,
      testMode: true,
      trxFrom: 'WEB'
    }
    // Store payment information for transaction history
    localStorage.setItem('paymentList', 'wallet');
    localStorage.setItem('paymentMethod', 'YOCO');
    localStorage.setItem('paymentAmount', this.amount);
    
    console.log('Starting Yoco payment with amount:', this.amount);
    
    this.commonService.showSpinner();
    this.commonService.postApi(url, data, 1).subscribe((res: any) => {
      if (res["responseCode"] == 200) {
        this.commonService.hideSpinner();
        
        console.log('Yoco payment response received');
        
        // Direct URL response (like Ozow implementation)
        if (typeof res.result === 'string') {
          console.log('Redirecting to Yoco payment URL');
          this.YocoUrl = res.result;
          this.yocoRedirect();
        }
        // Legacy format handling (HTML form)
        else if (res.result && res.result.file) {
          this.htmlData = this.sanitizer.bypassSecurityTrustHtml(res.result.file);
          
          const urlMatch = res.result.file.match(/action="([^"]+)"/);
          if (urlMatch && urlMatch[1]) {
            console.log('Extracted Yoco URL, redirecting...');
            this.YocoUrl = urlMatch[1];
            this.yocoRedirect();
          } else {
            console.log('No URL found in HTML, using form submission');
            // The HTML will auto-submit via onload
          }
        } else if (res.result && res.result.checkoutUrl) {
          console.log('Direct URL provided, redirecting...');
          this.YocoUrl = res.result.checkoutUrl;
          this.yocoRedirect();
        } else {
          this.commonService.errorToast("Invalid Yoco payment response");
        }
      } else {
        this.commonService.hideSpinner();
        console.error('Yoco payment error:', res["responseMessage"]);
        this.commonService.errorToast(res["responseMessage"])
      }
    }, (err) => {
      this.commonService.hideSpinner();
      console.error('Server error during Yoco payment:', err);
      this.commonService.errorToast("Server error during Yoco payment setup")
    });
  }

  ozhoRedirect() {
    console.log('Redirecting to Ozow URL:', this.OzhoUrl);
    window.location.href = this.OzhoUrl
  }

  paygateWalletPayment() {
  const url = `payment/checkoutWalletPayGate`;
  const data = {
    webFailure: this.commonService.webSiteUrl + 'customer-payment-cancel',
    webError: this.commonService.webSiteUrl + 'customer-payment-error',
    webSuccess: this.commonService.webSiteUrl + 'customer-payment-success',
    amount: this.amount,
    testMode: false,
    trxFrom: 'WEB'
  };

  // Store for post-return refresh
  localStorage.setItem('paymentList', 'wallet');
  localStorage.setItem('paymentMethod', 'PAYGATE');
  localStorage.setItem('paymentAmount', String(this.amount));
  localStorage.setItem('returningFromPayment', 'true');

  this.commonService.showSpinner();
  this.commonService.postApi(url, data, 1).subscribe(
    (res: any) => {
      this.commonService.hideSpinner();
      if (res?.responseCode === 200 && res?.result?.file) {
        this.htmlData = this.sanitizer.bypassSecurityTrustHtml(res.result.file);
        // The backend returns form id="paygate-wallet-form"
        this.autoSubmitInjectedForm('paygate-wallet-form');
      } else {
        this.commonService.errorToast(res?.responseMessage || 'Invalid PayGate response');
      }
    },
    (err) => {
      this.commonService.hideSpinner();
      this.commonService.errorToast('Server error');
      console.error('PayGate wallet error:', err);
    }
  );
}

  yocoRedirect() {
    console.log('Redirecting to Yoco URL:', this.YocoUrl);
    window.location.href = this.YocoUrl
  }
  
  openModal(){
    $('#addMoneyModal').modal('show')
    this.amount = null;
  }
  
  paymentMethod : any
  getPayamnetMethod(e){
    this.paymentMethod = e
    console.log('Selected payment method:', e);
  }
  
  onProceed(){
    console.log('Proceeding with payment method:', this.paymentMethod, 'amount:', this.amount);
    localStorage.setItem('paymentList', 'wallet')
    if(this.paymentMethod == 'ozow'){
      this.ozhoPayment()
    }
    else if(this.paymentMethod == 'yoco'){
      this.yocoPayment()
    }
    else if (this.paymentMethod === 'paygate') {
    this.paygateWalletPayment();
    }
  }
  autoSubmitInjectedForm(formId: string) {
  setTimeout(() => {
    const form: HTMLFormElement | null = document.getElementById(formId) as HTMLFormElement;
    if (form) form.submit();
  }, 0);
}
}
